import {
  defaultEntityState,
  IEntityState,
} from '@app/core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@app/core/state/entities/entity.helpers';
import { projectDetailActions } from '@app/core/actions/project-detail.actions';

import { IJoinRequest } from '@core/state/entities/join-request/join-request.entity';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';

export const joinRequestEntityReducer = createReducer(
  defaultEntityState<IJoinRequest>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.requestToJoinProjectResponseReceived,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.projectListingsLoaded,
    (state, props) => mergeEntityState(entityKey.joinRequests, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (joinRequest) => joinRequest.projectId === props.projectId
    )
  ),
  on(projectDetailActions.requestToJoinProjectCancelled, (state, props) =>
    mergeEntityState(
      entityKey.joinRequests,
      state,
      props,
      (joinRequest) => joinRequest.projectId === props.projectId
    )
  )
);
